var React = require('react');

function CloseIcon (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("polygon",{"points":"69.072,28.1 50,47.172 30.928,28.1 28.1,30.928 47.172,50 28.1,69.072 30.928,71.9 50,52.828 69.072,71.9    71.9,69.072 52.828,50 71.9,30.928  "})));
}

CloseIcon.defaultProps = {"version":"1.1","x":"0px","y":"0px","viewBox":"0 0 100 125","enableBackground":"new 0 0 100 100","xmlSpace":"preserve"};

module.exports = CloseIcon;

CloseIcon.default = CloseIcon;
